





































































































































import { defineComponent, computed, ref, PropType, watch } from '@vue/composition-api';
import BlankCreative from '@tt4b/ttam-assets/src/images/blank-creative.svg';
import { AdItem } from '../types';
import MoreActions from './more-actions.vue';
import { CreationStep } from '@tt4b/ttam-enums';

const name = 'ttam-sidebar-creative-node';
export default defineComponent({
  name,
  components: {
    MoreActions,
    BlankCreative,
  },
  props: {
    adInfo: {
      type: Object as PropType<AdItem>,
      default: () => ({}),
    },
    curUid: {
      type: String,
      default: '',
    },
    itemIndex: {
      type: Number,
      default: 1,
    },
  },
  setup(props, { emit }) {
    const isDraftStatus = computed(() => props.adInfo.adStatus === 'draft');
    const isPublishedStatus = computed(() => props.adInfo.adStatus === 'published');
    const isErrorStatus = computed(() => props.adInfo.adStatus === 'error');
    const isWarningStatus = computed(() => props.adInfo.adStatus === 'warning');
    const isFinishStatus = computed(() => props.adInfo.adStatus === 'finish');
    // eslint-disable-next-line @tt4b/no-single-dependency-computed
    const isACOPublishedStatus = computed(() => props.adInfo.adStatus === 'acopublished');

    const isActive = computed(() => props.adInfo.adUid === props.curUid);
    const actionConfig = computed(() => props.adInfo.actionConfig || []);

    const showCopyIcon = computed(() =>
      actionConfig.value.find(item => item.eventName && item.eventName === 'copy-creative'),
    );

    const copyIconEffect = computed(() => (showCopyIcon.value?.disabled ? 'light' : 'dark'));

    const copyIconHint = computed(() => {
      const { disabled, disabledHint, name: iconHint } = showCopyIcon.value;
      return disabled ? disabledHint : iconHint;
    });

    const copyIconPlacement = computed(() => (showCopyIcon.value?.disabled ? 'right' : 'top'));

    const showMoreIcon = ref(false);
    const showIcon = computed(() => isActive.value || showMoreIcon.value);

    function handleMouseEnter() {
      showMoreIcon.value = true;
    }

    function handleMouseLeave() {
      showMoreIcon.value = false;
    }

    function handleCreativeSelect() {
      if (props.adInfo.disabled || isFinishStatus.value || isActive.value) {
        return;
      }
      emit('select-creative', props.adInfo.adUid);
    }

    function handleEventClick(eventName: string, isShortcutTrigger = false) {
      // 统一处理一下 disabled/loading
      const actionItem = actionConfig.value.find(item => item.eventName && item.eventName === eventName);
      if (actionItem?.disabled || actionItem?.loading) {
        return;
      }
      emit('action', eventName, {
        adUid: props.adInfo.adUid,
        adIndex: props.itemIndex,
        isShortcutTrigger,
      });
    }

    function handleMoreBtnClick() {
      emit('action', 'more-btn-click', {
        adUid: props.adInfo.adUid,
        adIndex: props.itemIndex,
      });
    }

    function goToListPage(level: CreationStep, uuid: string) {
      emit('goToListPage', level, uuid);
    }

    return {
      name,
      isActive,
      isDraftStatus,
      isACOPublishedStatus,
      isPublishedStatus,
      isErrorStatus,
      isWarningStatus,
      isFinishStatus,
      showCopyIcon,
      copyIconEffect,
      copyIconHint,
      copyIconPlacement,
      showIcon,
      actionConfig,
      BlankCreative,

      handleMouseEnter,
      handleMouseLeave,
      handleEventClick,
      handleMoreBtnClick,
      handleCreativeSelect,
      goToListPage,
      CreationStep,
    };
  },
});
